import { createUseStyles } from "react-jss";

export const usePortalStyles = createUseStyles({
  fullScreenModal: {
    bottom: 0,
    left: 0,
    position: "fixed",
    right: 0,
    top: 0,
  },
});
